import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Task\GetTaskActivitiesByIdController::__invoke
* @see app/Http/Controllers/Task/GetTaskActivitiesByIdController.php
* @route '/api/task/{task}/activities'
*/
const GetTaskActivitiesByIdController = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTaskActivitiesByIdController.url(args, options),
    method: 'get',
})

GetTaskActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/task/{task}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Task\GetTaskActivitiesByIdController::__invoke
* @see app/Http/Controllers/Task/GetTaskActivitiesByIdController.php
* @route '/api/task/{task}/activities'
*/
GetTaskActivitiesByIdController.url = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { task: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { task: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            task: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        task: typeof args.task === 'object'
        ? args.task.id
        : args.task,
    }

    return GetTaskActivitiesByIdController.definition.url
            .replace('{task}', parsedArgs.task.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Task\GetTaskActivitiesByIdController::__invoke
* @see app/Http/Controllers/Task/GetTaskActivitiesByIdController.php
* @route '/api/task/{task}/activities'
*/
GetTaskActivitiesByIdController.get = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTaskActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Task\GetTaskActivitiesByIdController::__invoke
* @see app/Http/Controllers/Task/GetTaskActivitiesByIdController.php
* @route '/api/task/{task}/activities'
*/
GetTaskActivitiesByIdController.head = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTaskActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetTaskActivitiesByIdController